<template>
    <MstBukaEdit />
</template>

<script lang="ts">
import {defineComponent } from 'vue'
import MstBukaEdit from '@/components/master/buka/BukaEdit.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      MstBukaEdit
    }
})
</script>
